import React from 'react'
import 'swiper/swiper.min.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Cards, CardConstructor } from './comp/card-item'
import SwiperCore, { Lazy, Pagination, SwiperOptions, Autoplay } from 'swiper/core'
import styles from './index.module.less'
import { getProductsDetail } from './service'
import { currencySymbolMap } from '@/constant'
import { formatMoney } from '@/utils'

SwiperCore.use([Lazy, Pagination, Autoplay])
export enum SpuIdType {
  SPUID = 'SPUID',
  商品货号 = '商品货号',
}
export interface IProps {
  uid: string
  propsConfig: {
    dataList: Cards[]
    idArr: string[]
    showBanner: boolean
    spuIdType: SpuIdType
  }
  CName: string
  globalConfig: GlobalConfig
  subType: string
  editConfig: {
    lang: string
    local: string
  }
}

interface GlobalConfig {
  title: string
  style: {
    background: string
  }
  share: {
    title: string
    content: string
    icon: string
  }
  useSearchBar: number
}

interface IStates {
  cardlist?: Cards[]
  showBanner?: boolean
  renderStatus?: boolean
  idArr?: string[]
  noDate?: boolean
}

class PoizonShoppingGuideBanner extends React.Component<IProps, IStates> {
  static config = {
    name: 'poizon-shopping-guide-banner',
  }
  // 全部数据
  cardlist: Cards[] = []
  // 是不是显示
  showBanner = false
  // 是否显示数据
  renderStatus = false

  constructor(props: IProps) {
    super(props)
    // 没有数据的提示页面
    if (!props.propsConfig) {
      this.state = {
        noDate: true,
      }
      return
    }

    // 解决没有 init 没有 props 的问题
    const { showBanner = false, dataList, idArr } = props.propsConfig
    const renderStatus = false
    // if (dataList.length > 0) renderStatus = true;

    this.state = {
      cardlist: dataList,
      renderStatus,
      showBanner,
      idArr,
      noDate: false,
    }
  }

  handleCurrency = () => {
    const local = this.props.editConfig.local
    return currencySymbolMap[local]
  }

  async oldHistory(language, countryCode, idArr) {
    // 可以填写货号 + spuId，这个希望在PC做兜底
    // 历史兼容
    const params = {
      language,
      countryCode,
      spuIdInfo: JSON.stringify(
        idArr.map((item, index) => {
          return {
            spuId: item,
            index,
          }
        })
      ),
    }

    return await getProductsDetail(params)
  }

  async newSend(language, countryCode, idArr) {
    idArr = idArr.map((item, index) => {
      const key = item.spuIdType === SpuIdType.SPUID ? 'spuId' : 'itemNum'
      return { [key]: item.id, index }
    })

    const params = {
      language,
      countryCode,
      spuIdInfo: JSON.stringify(idArr.filter((item) => item.spuId)),
    }

    const params2 = {
      language,
      countryCode,
      itemInfo: JSON.stringify(idArr.filter((item) => item.itemNum)),
    }

    const arr = new Array(idArr.length)

    const spuIdById = {}

    if (params.spuIdInfo.length > 0) {
      const {
        data: { children: data, spuDTOList },
        status,
      } = await getProductsDetail(params)

      // 防止spuId没有
      for (const i in spuDTOList) {
        spuIdById[spuDTOList[i].spuId] = spuDTOList[i].spuId
      }

      if (status === 200) {
        Array.isArray(data) &&
          data.map((item) => {
            console.log(item)
            item.spuId = spuIdById[item.spuId]
            arr[+item.index] = item
          })
      }
    }

    if (params2.itemInfo.length > 0) {
      const {
        data: { children: data, spuDTOList },
        status,
      } = await getProductsDetail(params2)
      // 防止spuId没有
      for (const i in spuDTOList) {
        spuIdById[spuDTOList[i].spuId] = spuDTOList[i].spuId
      }

      if (status === 200) {
        Array.isArray(data) &&
          data.map((item) => {
            item.spuId = spuIdById[item.spuId]
            arr[+item.index] = item
          })
      }
    }

    console.log(arr)

    return arr
  }

  async componentDidMount() {
    const {
      editConfig: { lang, local },
      propsConfig: { idArr },
    } = this.props

    if (typeof idArr[0] === 'string') {
      const {
        data: { children: data },
        status,
      } = await this.oldHistory(lang, local, idArr)

      this.httpDeal(data, status)
    } else {
      const data = await this.newSend(lang, local, idArr)
      this.httpDeal(data, 200)
    }
    // 可以填写货号 + spuId，这个希望在PC做兜底
    // 历史兼容
  }

  httpDeal(data, status) {
    if (status === 200) {
      const goods = {}
      // 运气流派，祈祷spuId和itemNo不重复吧
      data.forEach((item) => {
        goods[item.spuId] = item
        goods[item.itemNo] = item
      })

      const setAfter = this.state.cardlist
        .map((item) => {
          let goodsNum = 0
          item.products = item.products.map((product) => {
            const matchedGoods = goods[product.id]
            if (!matchedGoods) {
              return product
            }

            goodsNum++
            return {
              ...product,
              subTitle: product.subTitle || matchedGoods.title,
              price: matchedGoods.price,
              priceShow: `${this.handleCurrency()}${formatMoney(matchedGoods.price)}`,
              logoUrl: matchedGoods.cover,
              spuId: matchedGoods.spuId,
            }
          })

          return {
            ...item,
            goodsNum,
          }
        })
        .filter(({ goodsNum }) => {
          return +goodsNum === 3
        })

      this.setState({
        cardlist: setAfter,
        renderStatus: true,
      })
    }
  }

  render() {
    const { renderStatus, noDate } = this.state
    const { lang } = this.props.editConfig

    if (noDate) return <div>请在左侧输入数据后查看</div>

    let renderTmp = null

    if (renderStatus) {
      const { cardlist, showBanner } = this.state

      const slides = cardlist.map((card, index) => {
        return (
          <SwiperSlide key={index}>
            <CardConstructor lang={lang} card={card} showBanner={showBanner} />
          </SwiperSlide>
        )
      })

      const swiperParams: SwiperOptions = {
        lazy: {
          loadPrevNext: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      }

      if (cardlist.length > 1) {
        swiperParams.pagination = {
          el: `.${styles['swiper-pagination']}`,
          clickable: true,
          bulletClass: `${styles['swiper-pagination-bullet']}`,
          //需设置.my-bullet样式
          bulletActiveClass: `${styles['swiper-pagination-bullet-active']}`,
        }
      }

      renderTmp = (
        <Swiper className={cardlist.length <= 1 ? 'swiper-no-swiping' : ''} {...swiperParams}>
          {slides}
          {cardlist.length <= 1 ? '' : <div className={styles['swiper-pagination']}></div>}
        </Swiper>
      )
    }

    return <div className={styles['container']}> {renderTmp} </div>
  }
}

export default PoizonShoppingGuideBanner
